import React, { ReactNode, memo, useCallback } from 'react';
import { Modal as AntModal, ModalProps } from 'antd';
import { useTranslation } from 'react-i18next';

interface Props extends ModalProps {
  children?: ReactNode;
  title?: string;
  onOk: any;
  onCancel: any;
  open: any;
  id?: any;
  text: any;
}

const Modal = memo<Props>(
  ({ children, title, onOk: _onOk, onCancel, open, id, text }) => {
    const { i18n } = useTranslation();

    const onOk = useCallback(() => {
      _onOk?.(id);
    }, [id, _onOk]);
    return (
      <AntModal
        closable={false}
        title={text}
        centered
        {...{ onOk, open, onCancel }}
        okText={i18n.t('yes')}
        cancelText={i18n.t('no')}
      >
        {children}
      </AntModal>
    );
  }
);

export { Modal };
